import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,isEmptyVariable, isEmptyArray,validateFile, handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import SpinnerLoader from 'react-loader-spinner';
import {DialogSaveButton,UploadSampleLayout} from '../../../common/Global/globalStyles.style';

let userDetails = getLocalStorageVariables();

class UploadDocumentSample extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            submitClickedAtleastOnce:false,
            uploadFileArr:[
                {
                    fileName:"",
                    originalFileName:"",
                    fileId:"file_1",
                    isUploading:false,
                    remark:"",
                    newlyAdded:true,
                    errors:{}
                }
            ],
            apiErr:"",
            uniqueIdCount:1,
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showUploadDocSampleDialog){
            this.setState({
                componentDidMountFlag:false,
                showLoader:false,
                submitClickedAtleastOnce:false,
                uploadFileArr:[
                    {
                        fileName:"",
                        originalFileName:"",
                        fileId:"file_1",
                        isUploading:false,
                        remark:"",
                        newlyAdded:true,
                        errors:{}
                    }
                ],
                apiErr:"",
                uniqueIdCount:1,
            })
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        let uploadFileArrTemp = this.state.uploadFileArr;
        uploadFileArrTemp[name].remark = value;

        if(this.state.submitClickedAtleastOnce){
            if(!isEmptyVariable(uploadFileArrTemp[name].remark) && 
            uploadFileArrTemp[name].remark.length > Constants.REMARKS_STRING_LENGTH){
                uploadFileArrTemp[name].errors['remark'] = "Remarks must be less then "+Constants.REMARKS_STRING_LENGTH+" characters";
            }else{
                uploadFileArrTemp[name].errors['remark'] = "";
            }
        }

        this.setState({
            uploadFileArr:uploadFileArrTemp,
        })
    }

    handleAddNewClick = () => {
        let uniqueIdCount = this.state.uniqueIdCount + 1;
        let newObj = {
            fileName:"",
            originalFileName:"",
            fileId:"file_"+uniqueIdCount,
            isUploading:false,
            remark:"",
            newlyAdded:true,
            errors:{}
        }
        let uploadFileArrTemp = this.state.uploadFileArr;
        uploadFileArrTemp.push(newObj);

        this.setState({
            uploadFileArr:uploadFileArrTemp,
            uniqueIdCount:uniqueIdCount
        })
    }

    handleDeleteItemClick = (index) => {
        let uploadFileArrTemp = this.state.uploadFileArr;
        uploadFileArrTemp.splice(index,1);
        this.setState({
            uploadFileArr:uploadFileArrTemp,
        })
    }

    uploadDocumentsApi = () => {
        this.setState({
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let apiErrTemp = "";
        let uploadFileArrTemp = this.state.uploadFileArr;

        uploadFileArrTemp.map((item,index)=>{
            if(item.isUploading){
                isError = true;
                apiErrTemp = "Files are being uploaded. Please wait";
            }

            if(isEmptyVariable(item.fileName)){
                isError = true;
                uploadFileArrTemp[index].errors['uploadFileErr'] = "Please upload a file";
            }

            if(!isEmptyVariable(item.remark)){
                if(item.remark > Constants.REMARKS_STRING_LENGTH){
                    isError = true;
                    uploadFileArrTemp[index].errors['remark'] = "Remarks must be less then "+Constants.REMARKS_STRING_LENGTH+" characters";
                }

            }
        })

        if(isError){
            this.setState({
                uploadFileArr:uploadFileArrTemp,
                apiErr:apiErrTemp,
                showLoader:false
            });
        }else{
            //return uploadFileArr
            let url = "";
            let postParam = {
                email: userDetails.email,
				accessToken: userDetails.accessToken,
				assignmentTaskId: this.props.assignmentTaskId,
				tmpAnnexureFileArr:JSON.stringify(this.state.uploadFileArr)
            }
            if(this.props.type == "Annexure"){
                url = Constants.SaveAssignmentTaskAnnexureFiles;
            }else if(this.props.type == "Backup"){
                url = Constants.SaveAssignmentTaskBackupFiles;
            }

            if(this.props.isDraftOnward === true){
                postParam.forDraft = true;
                if(this.props.type == "Annexure"){
                    url = Constants.SaveDraftAssignmentTaskAnnexures;
                }else if(this.props.type == "Backup"){
                    url = Constants.SaveDraftAssignmentTaskBackups;
                }
            }

            fetch(url, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			})
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if (data.responseCode === Constants.CODE_SUCCESS) {
                    this.props.returnUploadedArray(this.state.uploadFileArr);
                } else {
                }
            });
            // this.props.returnUploadedArray(this.state.uploadFileArr);
        }
    }

    changeImage = async (index, e) => {
        e.preventDefault();

        const input = e.target;
        const file = input.files?.[0]; // Save the file immediately
        if (!file) return;

        const result = await validateFile(file);
        let uploadFileArrTemp = [...this.state.uploadFileArr];
        let fileSlot = uploadFileArrTemp[index];

        if(!isEmptyVariable(file)){
            // let uploadFileArrTemp = this.state.uploadFileArr;
            fileSlot.isUploading=true;
            fileSlot.originalFileName=file.name;

            this.setState({
                uploadFileArr:uploadFileArrTemp,
            })

            if(!result.valid){
                fileSlot.isUploading=false;
                fileSlot.originalFileName="";
                fileSlot.errors.uploadFileErr = result.message;
                this.setState({
                    uploadFileArr:uploadFileArrTemp,
                });
                return;
            }else{
                const formData = new FormData();
                
                formData.append('documentSample',file);
                formData.append('email',userDetails.email);
                formData.append('accessToken',userDetails.accessToken);

                let url = "";
               
                if(this.props.isDraftOnward === true){
                   formData.append('forDraft',true);
                    if(this.props.type == "Annexure"){
                        url = Constants.UploadDraftAssignmentTaskAnnexure;
                    }else if(this.props.type == "Backup"){
                        url = Constants.UploadDraftAssignmentTaskBackup;
                    }
                }else{
                    if(this.props.type == "Annexure"){
                        url = Constants.UploadAssignmentTaskAnnexure;
                    }else if(this.props.type == "Backup"){
                        url = Constants.UploadAssignmentTaskBackup;
                    }
                }
               

                fetch(url,
                {
                    method: "POST",
                    mode: 'cors',
                    body: formData
                })
                .then(response => { return response.json(); })
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        fileSlot.isUploading=false;
                        fileSlot.fileName=data.fileName;
                        fileSlot.errors={};
                        this.setState({
                            uploadFileArr:uploadFileArrTemp,
                        });
                    }else{
                        fileSlot.isUploading=false;
                        fileSlot.originalFileName="";
                        fileSlot.errors.uploadFileErr=data.responseMessage;
                    }
                });
            }
        }
    }

    render() {
        return(
            <Modal className="upload-doc-sample-dialog custom-dialog" 
            show={this.props.showUploadDocSampleDialog} backdrop="static">
                <Modal.Header>
                    <h5>Upload {this.props.type}</h5>
                    <button 
                        onClick={this.props.handleUploadSampleDocDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    {
                        this.state.showLoader &&
                        <div class="loader"></div>
                    }
                    <div className="addnew-modal-form">
                    {
                        !isEmptyArray(this.state.uploadFileArr) &&
                        this.state.uploadFileArr.map((item,index) => {
                            return <div className="row custom-row">
                                    <div className="col-md-12 custom-col">
                                        <div className="addnew-modal-form-group  m-b-10">
                                            <p>{this.props.type}*</p>
                                            <div className="flex-center-layout">
                                                <input type="text" placeholder={`Select ${this.props.type}`}
                                                    value={item.originalFileName}
                                                    disabled={true}
                                                />
                                                <UploadSampleLayout themeSettings={this.props.themeSettings}>
                                                    <input name="file" 
                                                        type="file"
                                                        id={item.fileId}
                                                        onChange={this.changeImage.bind(this,index)}
                                                        disabled={item.isUploading}
                                                    />
                                                    <label disabled={item.isUploading} for={item.fileId}>Upload</label>
                                                </UploadSampleLayout>
                                                {
                                                    index !== 0 &&
                                                    <span className="material-icons delete-doc-row"
                                                    onClick={this.handleDeleteItemClick.bind(this,index)}>
                                                        delete
                                                    </span>
                                                }
                                            </div>
                                            {
                                                !isEmptyVariable(item.errors['uploadFileErr']) &&
                                                <span class="cm-error">{item.errors['uploadFileErr']}</span>
                                            }
                                            {
                                                item.isUploading &&
                                                <div className="flex-center-layout single-line m-t-5">
                                                    <SpinnerLoader style={{ marginLeft:5 }} 
                                                        type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                    <span class="loading-span" style={{ marginLeft:5 }}>Uploading document</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-12 custom-col">
                                        <div className="addnew-modal-form-group m-b-0">
                                            <p>Remarks</p>
                                            <textarea type="text" placeholder="Enter Remarks"
                                            name={index} value={item.remark} onChange={this.handleChange}/>
                                            {
                                                !isEmptyVariable(item.errors['remark']) &&
                                                <span className="cm-error">{item.errors['remark']}</span>
                                            }
                                        </div>
                                    </div>
                                    {
                                        (index !== (this.state.uploadFileArr.length - 1)) &&
                                        <hr className="doc-upload-divider"/>
                                    }
                                    
                                </div>
                            })
                        }
                        <div className="row custom-row">
                            <div className="col-md-12 custom-col">
                                <div className="add-more-btn-layout" onClick={this.handleAddNewClick}>
                                    <span className="material-icons">add_circle</span>
                                    <p>Add New</p>
                                </div>
                            </div>
                        </div>
                        {
                            !isEmptyVariable(this.state.apiErr) &&
                            <span className="cm-error">{this.state.apiErr}</span>
                        }
                    </div>
                    
                    <div className="modal-close-save">
                        <div className="close-save-col">
                            <button onClick={this.props.handleUploadSampleDocDialogClose} type="button" className="modal-close">Cancel</button>
                            <DialogSaveButton
                            themeSettings={this.props.themeSettings}
                            onClick={this.uploadDocumentsApi} type="button">Save</DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default UploadDocumentSample;